import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  CardFooter,
  FormGroup,
  Form,
} from "reactstrap";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class ParentCampEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      camp: props.camp || {},
    };
    this.updateCampDetails = this.updateCampDetails.bind(this);
    this.createCampDetails = this.createCampDetails.bind(this);
  }

  componentDidMount() {}

  createCampDetails = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "/camp/createParentCamp",
        method: "POST",
        data: {
          name: this.state.camp.name,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateCampDetails = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "/camp/updateParentCamp",
        method: "POST",
        data: {
          name: this.state.camp.name,
          campId: this.state.camp._id,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  closeEditPage = (value) => {
    this.props.closeCampEditPage();
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={
            this.props.campEditKey ? "Edit Parent Event" : "Add Parent Event"
          }
          breadcrumbs={[
            {
              name: this.props.campEditKey
                ? "Edit Parent Event"
                : "Add Parent Event",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.campEditKey
                        ? this.updateCampDetails
                        : this.createCampDetails
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Name :</Label>
                          <Input
                            type="text"
                            name="name"
                            required
                            value={this.state.camp.name || ""}
                            placeholder="Name"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                camp: {
                                  ...this.state.camp,
                                  name: event.target.value,
                                },
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        {this.props.campEditKey ? (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default ParentCampEdit;
